// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KqomSGcmXsq9MW8fBDZQ{position:relative;width:100%;height:100%;overflow:hidden;background-color:var(--dark-text)}`, "",{"version":3,"sources":["webpack://./src/components/Rules/rules.module.scss"],"names":[],"mappings":"AAAA,sBACI,iBAAA,CACA,UAAA,CACA,WAAA,CACA,eAAA,CACA,iCAAA","sourcesContent":[".rules {\n    position: relative;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    background-color: var(--dark-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rules": `KqomSGcmXsq9MW8fBDZQ`
};
export default ___CSS_LOADER_EXPORT___;
